<!--接口管理-->
<template>
  <Card dis-hover class="contentArea" style="position: relative">
    
        <packageTable
        tableName="areaClass"
        ref="contentBaseRef" 
        class="contentBaseRef"
        :tableData="tableData"
        :columnsData="columnsData"
        :loading="tableLoading"
        :tabletotallen="tabletotallen"
        :border="border"
        :stripe="stripe"
        :showSearchBtn="false"
        :showSearch="false"
        rowKey="area_name"
        :tablePageSize="reqBase.page_size"
        @handleLoadData="handleLoadData"
        @pageonChange="pageonChange"
        @pageSizeChange="pageSizeChange"
        @showSearchParel="showSearchParel"
        @refreshBtn="init"> 
      
            <template slot="headLeft">
              <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                <Button  
                    :type="item.type"      
                    style="margin-right: 5px;" 
                    @click="item.method" 
                    :key="index" 
                    :icon="item.icon"></Button>
            </Tooltip> 
          </template>
      </packageTable>
   
  </Card>
</template>

<script>
  import packageTableMixins from "@/mixins/packageTableMixins.js";
  import addCom from './components/addCom'
  import {area_list,area_add,area_update,area_del} from '@/api/jingxiaoshang'
  export default {  
    name: "areaClass",
    mixins: [packageTableMixins],
    data() {
      return {
        cateList:[],
        nodeList:[],
        showSearchMore:false,
        form_filter:{
          cate_name:null
        },
         //共用的右侧添加按钮
    topButtonList1:[
      {
        name:this.$t("add"),
        icon:'ios-add',
        type:'primary',
        method:this.add 
      },
      // {
      //   name:this.$t("refresh"),
      //   icon:'ios-refresh',
      //   type:'primary',
      //   method:this.init
      // }
    ],
        topButtonList:[
          {
            name:this.$t("query"),
            type:'primary',
            method:this.search
          },
          {
            name:this.$t("reset"),
            type:'error',
            method:this.reset
          }
        ],
        
        searchReq:{
          mods:[],
        },
        tableData:[
        ],
        columnsData:[
          // {
          //   title: this.$t("areamenu.serialnumber"),
          //   key: 'id',
          //   align: 'center',
          //   width:80,
          // },
          {
            title: this.$t("areamenu.regionname"),
            key: 'area_name',
            align: 'left',
            minWidth:120,
            tree:true
          },
          {
            title: this.$t("operation"),
            key: 'explain',
            align: 'center',
            width:300,
            render:(h,{row})=>{
              let arr=[
                h("Button",{
                  style:{
                    marginRight:"3px",
                    marginBottom:'3px',
                    color:'#2d8cf0',
                  },
                  props:{
                    size:"small",
                    type:'text',
                  },
                  on:{
                    "click":()=>{
                      this.addChlid(row);
                    }
                  }
                },this.$t("areamenu.addsubordinatearea"))
              ];
            
              arr.push(h("Button",{
                  style:{
                    marginRight:"3px",
                    marginBottom:'3px',
                    color:'#2d8cf0',
                  },
                  props:{
                    size:"small",
                    type:'text',
                  },
                  on:{
                    "click":()=>{
                      this.edit(row);
                    }
                  }
                },this.$t("edit")));
                arr.push(h("Button",{ 
                  style:{
                    marginRight:"3px",
                    marginBottom:'3px',
                    color:'#2d8cf0',
                  },
                  props:{
                    size:"small",
                    type:'text'
                  },
                  on:{
                    "click":()=>{
                      this.del(row);
                    }
                  }
                },this.$t("delete")));
              return h("div",arr);
            }
          }
        ],
        tableLoading:false,
        tabletotallen:0,
        border:true,
        stripe:true,
        moduleShow:false,
        addBase:{
          name:"",
          code:"",
          state:"",
          explain:""
        },
        reqBase:{
          page:1,
          parent_code: 1,
          all:1
        },
        states:[
          {
            value:0,
            label:"禁用"
          },
          {
            value:1,
            label:"启用"
          }
        ],
        modalTitle:true,
        ruleValidate:{
          name: [
            { required: true, message: '请输入模块名', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入模块代码', trigger: 'change' }
          ],
          explain:[
            { required: true, message: '请输入说明', trigger: 'blur' }
          ],
          state:[
            { required: true, message: '请选择状态', trigger: 'change' }
          ]
        }
      }
    },
    components: {

    },
    computed: {
      modelList(){
        return this.$store.state.authCenter.ModuleData;
      }
    },
    methods: {
      handleLoadData(item, callback) {
        console.log("11111")
        const vm = this;
        let callbak = res => {
          if(res.result === 0){
            let data=res.body.list||[]
            for(let i in data){
              let list=data[i]
              if(list.has_child===1){
                list._loading=false
                list.children=[]
                list.parent_code=item.area_code
                list.parent_name=item.area_name
              } 
            }
            callback(data)
          }else {
          }
        };
        area_list({
          page_size:-1,
          page:1,
          parent_code: item.area_code,
          all:1
          // project_code:vm.projectCode,
          // parent_code:item.cate_code
        }).then(res => {
          callbak(res); 
        }).catch(err=>{
          // this.tableLoading=false;
        })
      },
      createTree(data){
        for(let i in data){
          let list=data[i]
          list['value']=list.node_code
          list['label']=list.node_name
          if(list.children && list.children.length>0){
            this.createTree(list.children)
          }
        }
      },
      createTree1(data){
        for(let i in data){
          let list=data[i]
          list['value']=list.cate_code
          list['label']=list.cate_name
          if(list.children && list.children.length>0){
            this.createTree1(list.children)
          }
        }
      },
    getTreeCateNodeData(callback){
      this.spinShow=true;
      this.cateList.splice(0)
      patrolcateGetAllCate({
        project_code:this.$store.state.user.projectCode
      }).then(res=>{
        this.spinShow=false
        if(res.result===0){
          let data=res.body
          this.createTree1(data)
          this.cateList.push(...data)
          if(callback){
            callback(this.cateList)
          }
        }else{

        }
        
      })
    },
    getTreeNodeData(callback){
      this.spinShow=true;
      this.nodeList.splice(0)
      get_all_cate({
        project_code:this.$store.state.user.projectCode
      }).then(res=>{
        this.spinShow=false
        if(res.result===0){
          let data=res.body
          this.createTree(data)
          this.nodeList.push(...data)
          if(callback){
            callback(this.nodeList)
          }
        }else{

        }
        
      })
    },
      /**
       * 修改状态
       */
      changeStatus(row,title){
        const _this = this;
        let config = {
          loading:true,
          title:title,
          width:400,
          content:`<p>您确认要${title}<span style="color: #f60;">${row.plan_name}</span>？</p>`,
          onOk:()=>{
            let params = {
              plan_code:row.plan_code
            },callbak = req => {
              if(req.result === 0){
                this.$Message.success(req.errorMsg);
                this.$Modal.remove();
                this.init();
              }else {
                this.buttonLoading=false;
                this.$Message.error(req.errorMsg);
              }
            };
            //删除接口
            handle_catch_fear_status(params).then(res=>{
              callbak(res)
            });
          }
        };
        this.$Modal.confirm(config)
      },
      showMore(){
        if(!this.showSearchMore){
          this.showSearchMore=true
        }else{
          this.showSearchMore=false
        }
      },
      init(){
        this.getPageSizeToStorage();
        this.getData();
      },
      
      
      /**
       * 初始化数据
       */
      getData(){
        this.tableData.splice(0)
        this.tableLoading=true;
        const vm = this;
        let callbak = res => { 
          this.tableLoading=false;
          if(res.result === 0){
            let data = res.body.list || []
            console.log(data) 
            for(let i in data){
              let list=data[i]
              if (list.has_child == 1) {
               // console.log(Vue.version) 
                list._loading=false
                list.parent_code='0'
                list.parent_name=this.$t("nodata"),
                list.children=[]
              }  
              console.log(list)
              vm.tableData.push(list)

            }
            console.log(vm.tableData)
            vm.tabletotallen = res.body.total;
          }else {
            vm.tableData = [];
            this.$Message.error(res.errorMsg);
          }
        };
        area_list(this.reqBase).then(res => {
          callbak(res);
        }).catch(err=>{
          this.tableLoading=false;
        })
      },
      /**
       * 重置搜索框
       */
      resetSearch(){
        this.searchReq={
          mods:[]
        }
      },
      okSearch(){
        Object.assign(this.reqBase,this.searchReq);
        //重置当前页为1
        this.reqBase.page=1;
        this.$refs.contentBaseRef.initcurrentPage();
        this.init();
      },
      /**
       * 翻页
       */
      pageonChange(index){
        this.reqBase.page = index;
        this.getData();
      },
      /**
       * 筛选
       */
      showSearchParel(){
        this.$refs.search.expandPanel();
      },
      addChlid(row){
        let vm = this;
        let config = {
          loading: true,
          width: 500,
          render: (h) => {
          return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, this.$t("areamenu.addsubordinatearea"),),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                          vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom, {
                  ref: 'addCom',
                  props: {
                      _vm: vm,
                      $store:vm.$store,
                      edit:false,
                      parent_code:row.area_code,
                      parent_name:row.area_name, 
                  }
              })
          ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            obj.checkForm().then(res => {
            if (res) {
            area_add({...obj.formModel}).then(res => {
              let msg=res.errorMsg;
              if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init()
              } else {
              vm.$Message.error(msg);
                _this.buttonLoading = false;
              }
            });
            } else {
                _this.buttonLoading = false;
            }
          });
          }
        };
        this.$Modal.confirm(config);
      },
      add(){
       let vm = this;
        let config = {
          loading: true,
          width: 500,
          render: (h) => {
          return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, this.$t('areamenu.addarea')),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                          vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom, {
                  ref: 'addCom',
                  props: {
                      _vm: vm,
                      $store:vm.$store,
                      edit:false,
                      parent_code:'0',
                      parent_name:this.$t('nodata'),
                  }
              })
          ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            obj.checkForm().then(res => {
            if (res) { 
              area_add({...obj.formModel}).then(res => {
              let msg=res.errorMsg;
              if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove(); 
                vm.init()
              } else {
              vm.$Message.error(msg);
                _this.buttonLoading = false;
              }
            });
            } else {
                _this.buttonLoading = false;
            }
          });
          }
        };
        this.$Modal.confirm(config);
      },
      edit(row) {
        console.log('a',row)
        let vm=this;
        let config={
          loading:true,
          width:500,
          render:(h)=>{
            return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, this.$t('areamenu.editarea')),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                        vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom,{
                ref:'addCom',
                props:{
                  edit:true,
                  $store:vm.$store,
                  _vm:vm,
                  setData:row,
                }
              })
            ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            obj.checkForm().then(res => {
            if (res) {
              let { area_name, desc, area_code } = obj.formModel
       
              area_update({area_name, desc, area_code,type:1}).then(res => {
                let msg=res.errorMsg;
                if (res.result === 0) {
                  let msg=res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init()
                } else {
                vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
              } else {
                  _this.buttonLoading = false;
              }
            });
          }
        };
        this.$Modal.confirm(config);
      },
      
    search(){
      this.onSearch(this.form_filter);
    },
    reset() {
      this.form_filter={
         cate_name:null
      };
      this.search();
    },
    /**
     * 删除
     */
    del(row){
      let vm=this; 
        this.$Modal.confirm({
        title:this.$t('delete'),
        content:this.$t('isdelete')+" "+row.area_name+" "+this.$t('ma')+'？',
        loading:true,
        onOk:function(){
          let _this=this;
          area_del({area_code:row.area_code}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init()
            } else {
              vm.$Message.error(msg); 
              _this.buttonLoading = false;
            }
          });
        }
      })
    },
  },
  mounted() {
    this.$set(this.reqBase,'project_code',this.$store.state.user.projectCode)
    this.init();
   
  },
  created() {
  },
  destroyed(){
    window.onresize =null
  }
}
</script>

<style scoped>
  .btnFormItem /deep/ .ivu-form-item-content{
    margin-top:30px;
  }
  .searchForm /deep/ .ivu-form-item{
    margin-bottom:5px;
  }
</style>
